import firebase from "firebase/compat/app";
import moment from "moment";

const getMediaAttached = async function(competition_id, user_id) {
  let db = firebase.firestore();
  //get member infomation in each group
  const attachedList = [];
  const competitionData = await db
    .collection("wellness_competition")
    .doc(competition_id)
    .get();
  //get start / end
  let startDate = competitionData.data().startDate;
  let endDate = competitionData.data().endDate;

  const userMedicalNote = await db
    .collection("wellness_data")
    .doc(user_id)
    .collection("medical_note")
    .orderBy("date")
    .get();

  userMedicalNote.forEach((doc) => {
    const pictureMoment = moment(doc.data().date.toDate(), "YYYY-MM-DD");
    const startMoment = moment(startDate.toDate(), "YYYY-MM-DD");
    const endMoment = moment(endDate.toDate(), "YYYY-MM-DD")
      .add(7, "days")
      .format("YYYY-MM-DD");
    if (
      pictureMoment.isSameOrAfter(startMoment) &&
      pictureMoment.isSameOrBefore(endMoment)
    ) {
      attachedList.push({
        date: doc.data().date.toDate(),
        imageUrl: doc.data().imageUrl,
        note: doc.data().note,
        title: doc.data().title,
      });
    }
  });

  return attachedList;
};

export default getMediaAttached;
